import { Component } from '@angular/core';
import Echo from 'laravel-echo';
import { pusher } from 'pusher-js';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'control-panel';
  echo: any;

  constructor() {
    this.echo = new Echo({
      broadcaster: pusher,
      key: 'somekey',
      cluster: 'mt1',
      wsHost: window.location.hostname,
      wsPort: 6001,
      disableStates: true
    });


    /*this.echo.join(`chat`)
    .here((users) => {
        //
    })
    .joining((user) => {
        console.log(user.name);
    })
    .leaving((user) => {
        console.log(user.name);
    });*/

  }
}


